import { serviceName } from '../resources/serviceConstants';
// eslint-disable-next-line no-duplicate-imports
import { LEAVE_HISTORY_LIST } from '../resources/endPoint';

export const leaveUploadList = (stardDate, endDate) => {
  // API call to fetch role list
  const url
    = stardDate && endDate
      ? `${LEAVE_HISTORY_LIST}&start-date=${stardDate}&end-date=${endDate}`
      : LEAVE_HISTORY_LIST;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS,
  };
};
